var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrapperClass,style:(_vm.wrapperStyle)},[_c('div',{ref:"container",staticClass:"tp-link-video__container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }